<template>
  <div>
    <custom-dialog width="460px" v-if="visibleObj.registerDetailDialog" :visible="visibleObj.registerDetailDialog"
      @close="dialogVisible('registerDetailDialog')">
      <div slot="header">
        <div class="header">
          <img :src="statusObj.bgImg" class="bg-img">
          <div class="header-patient" :style="{ background: statusObj.bgColor }">
            <span class="mr20">{{ dialogObj.patientName }}</span>
            <span class="mr20">{{ dialogObj.sex == '0' ? '男' : '女' }}</span>
            <span class="mr20">{{ dialogObj.age }}岁{{ dialogObj.ageMth }}月</span>
            <span>{{ dialogObj.phone }}</span>
          </div>
        </div>
        <div class="lockset-tips" v-if="couponList.length > 0">该顾客获得优惠券</div>
      </div>
      <div class="content" slot="content">
        <div>
          <span class="mr12">医生：{{ dialogObj.doctorName }}</span>
          <span>{{ computedDoctorVisit }}</span>
          <span v-if="dialogObj.type == 8 || dialogObj.type == 9" class="colorFE8F ml12">补录挂号</span>
          <span v-if="dialogObj.type == 12" class="colorFE8F ml12">转方补录</span>
          <span v-if="dialogObj.referralStatus" class="referral-status">(已转诊给{{ dialogObj.referralDoctorName }})</span>
        </div>
        <div class="mt12">
          <span class="rigth-line pr0">号源：{{ dialogObj.schedulingTime }}</span>
          <span v-if="dialogObj.type != 8 && dialogObj.type != 9" class="rigth-line">{{
            dialogObj.timeQuantumName
          }}</span>
          <span v-if="dialogObj.type != 8 && dialogObj.type != 9" class="rigth-line">{{ dialogObj.registeredCode ?
            `${dialogObj.timeName}${dialogObj.registeredCode}号` : '签到后排号' }}</span>
          <span class="ml4" :style="{ color: statusObj.fontColor }">{{ computedStatus }}</span>
          <el-popover popper-class="popover-record" placement="right" width="400" trigger="click">
            <div class="timeline">
              <div class="timeline-item" v-for="(item, index) in changeRecordList" :key="index">
                <div class="timeline-dot" :class="{ active: index === changeRecordList.length - 1 }"></div>
                <div class="timeline-line" v-if="index !== changeRecordList.length - 1"></div>
                <div class="timeline-content">
                  <div class="timeline-header">
                    <span class="timeline-title">第{{ index + 1 }}次改签</span>
                    <span class="timeline-time">{{ item.operateTime || '' }} {{ item.operatorName || '' }}操作</span>
                  </div>
                  <div class="timeline-detail">
                    <div>原号源：{{ item.beforeSchedulingTime || '' }} | {{ item.beforeTimeName || '' }}</div>
                    <div class="mt2">新号源：{{ item.afterSchedulingTime || '' }} | {{ item.afterTimeName || '' }}</div>
                  </div>
                </div>
              </div>
            </div>
            <span class="change-record" v-show="changeRecordList.length > 0" slot="reference">改签记录<i
                class="el-icon-caret-right"></i></span>
          </el-popover>
        </div>
        <div class="mt12 price-item">挂号费：¥ {{ [null, undefined, ''].includes(dialogObj.registerFee) ? dialogObj.price : dialogObj.registerFee }}</div>
        <div class="mt12 price-item">优惠：￥ {{ computedDiscountAmount }}</div>
        <div class="mt12 price-item" v-if="dialogObj.discountAmount">议价：-¥ {{ dialogObj.discountAmount || 0 }}(优惠券)
        </div>
        <div class="mt12 price-item">
          <span>实收：¥ {{ dialogObj.finalPrice }}</span>
          <span v-if="dialogObj.status == '0'" class="ml8 colorFE8F">待付</span>
          <span v-if="dialogObj.status == '-3'" class="ml8 color6671">已退</span>
          <span v-if="['1', '2', '3', '-2'].includes(dialogObj.status)" class="ml8 color29C0">已收</span>
          <el-popover v-if="['1', '2', '3', '-3', '-2'].includes(dialogObj.status)" popper-class="price-popover"
            placement="top" width="203" trigger="hover">
            <i class="el-icon-question color9AA0 ml5" slot="reference"></i>
            <div>
              <div class="price-top">
                <div class="flex just-b">
                  <div>应收</div>
                  <div>¥{{ dialogObj.price }}</div>
                </div>
                <div class="flex just-b">
                  <div>实收</div>
                  <div>¥{{ dialogObj.realPay }}</div>
                </div>
              </div>
              <div class="price-bottom">
                <div class="flex just-b">
                  <div>收费 {{ dialogObj.payee }}</div>
                  <div class="color0000">¥{{ dialogObj.realPay }}</div>
                </div>
                <div class="flex just-b">
                  <div>{{ dialogObj.payTime }}</div>
                  <div>{{ dialogObj.payWay | filterWay(PAY_WAY) }}</div>
                </div>
              </div>
              <div class="price-bottom" v-if="dialogObj.status == '-3'">
                <div class="flex just-b">
                  <div>退费 {{ dialogObj.refundBy }}</div>
                  <div class="color0000">¥{{ dialogObj.refundPrice }}</div>
                </div>
                <div class="flex just-b">
                  <div>{{ dialogObj.refundTime }}</div>
                  <div>{{ dialogObj.refundWay | filterWay(PAY_WAY) }}</div>
                </div>
              </div>

            </div>
          </el-popover>
        </div>

        <div class="mt12">创建：{{ dialogObj.createBy }}（{{ dialogObj.createTime }}）</div>
        <div class="mt12" v-if="computedReferrerTypeShow && !dialogObj.referrerType">
          来源：<el-button type="text" class="referrer-button" @click="editReferrerType">点击补充患者来源</el-button>
        </div>
        <div class="mt12" v-if="!computedReferrerTypeShow && !dialogObj.referrerType">来源：<span class="editReferrerType">超出就诊日期，不允许补录</span></div>
        <div class="mt12" v-if="dialogObj.referrerType">来源：{{ dialogObj.referrerType | filterReferrerType(sourceConfigList) }}
          {{ dialogObj.referrer }}</div>
      </div>
      <div class="footer-tips" slot="footer" v-if="dialogObj.type == 8 || dialogObj.type == 9">
        <div>提示：补录挂号费的退款请在收费界面操作</div>
        <div class="mt10 textRight">
          <custom-button size="small" type="info" @click="print">打印</custom-button>
          <custom-button size="small" type="info" @click="dialogVisible('registerDetailDialog')">取消</custom-button>
        </div>
      </div>
      <div class="footer" slot="footer" v-else>
        <custom-button size="small" type="primary" v-if="isShowSignPrint" @click="handleRegister">签到并打印</custom-button>
        <template v-if="isShowCharge">
          <custom-button v-if="dialogObj.channelType == 80" size="small" type="primary" @click="charge">收费</custom-button>
          <custom-button v-if="dialogObj.channelType == 60" size="small" type="primary" @click="redeem">核销</custom-button>
        </template>
        <custom-button size="small" plain type="primary" v-if="isShowSign" @click="sign">签到</custom-button>
        <custom-button size="small" type="info" v-if="isShowPrint" @click="print">打印</custom-button>

        <el-dropdown v-if="isShowReturn || isShowReferral" trigger="click" @command="onMoreCommand">
          <custom-button size="small" type="info" style="margin: 0 0 0 10px;">更多</custom-button>
          <el-dropdown-menu slot="dropdown">
            <el-tooltip
              :disabled="!isRefundDisabled"
              content="仅号源日当天8点及8点前可退号"
              placement="left"
            >
              <span class="refund-dropdown-item">
                <el-dropdown-item v-if="isShowReturn" :disabled="isRefundDisabled" command="refund">
                  退号
                </el-dropdown-item>
              </span>
            </el-tooltip>
            <el-dropdown-item v-if="isShowReferral" :disabled="dialogObj.referralStatus"
              command="referral">转诊</el-dropdown-item>
            <el-dropdown-item v-if="isShowChange" command="change">改签</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <custom-button size="small" type="info" style="margin: 0 0 0 10px;"
          @click="dialogVisible('registerDetailDialog')">取消</custom-button>
      </div>
    </custom-dialog>
    <el-dialog title="请选择转诊医生" :visible.sync="referralMap.show" class="referral_dialog" width="340px"
      :before-close="referralClose">
      <div></div>
      <div class="referral_content">
        <el-form ref="referralForm" :model="referralMap.form" :rules="referralMap.rules" label-width="70px">
          <el-form-item label="转诊给" prop="doctorId">
            <el-select v-model="referralMap.form.doctorId" placeholder="选择转诊医生">
              <el-option v-for="item in dialogObj.referralDoctorList" :key="item.doctorId" :label="item.doctorName"
                :value="item.doctorId"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="referralClose">取 消</el-button>
        <el-button type="primary" @click="referralConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="补充患者来源" :visible.sync="referrerTypeMap.show" class="referral_dialog" width="400px"
      :before-close="referrerTypeClose">
      <div class="referral_content">
        <el-form ref="referrerTypeForm" :model="referrerTypeMap.form" :rules="referrerTypeMap.rules" label-width="70px">
          <el-form-item label="来源" prop="sourceId" class="source_warp">
            <custom-select class="select-el-input__inner" v-model="referrerTypeMap.form.sourceId" placeholder="请选择"
              :configs="sourceListConfig" @change="sourceChange" :options="sourceConfigList"></custom-select>
          </el-form-item>
          <el-form-item prop="referrerDoctorId" v-if="referrerTypeMap.form.sourceId == 10">
            <custom-select class="select-el-input__inner"
              :configs="doctorReferrerOptionsConfig" :popper-append-to-body="false" filterable
              v-model="referrerTypeMap.form.referrerDoctorId" remote reserve-keyword
              :remote-method="getSourceDoctorList" placeholder="选择医生" :options="doctorReferrerOptions"></custom-select>
          </el-form-item>
          <el-form-item prop="referrerUserId" v-if="referrerTypeMap.form.sourceId == 11">
            <custom-select class="select-el-input__inner"
              :configs="userOptionsConfig" :popper-append-to-body="false" filterable
              v-model="referrerTypeMap.form.referrerUserId" remote reserve-keyword :remote-method="getSourceUserList"
              placeholder="选择员工" :options="userOptions"></custom-select>
          </el-form-item>
          <el-form-item prop="referrerPhone" v-if="referrerTypeMap.form.sourceId == 9">
            <el-input v-model.number="referrerTypeMap.form.referrerPhone" maxlength="11" placeholder="推荐人号码"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="referrerTypeClose">取 消</el-button>
        <el-button type="primary" @click="referrerTypeConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <registerMeiTuanRedeem ref="registerMeiTuanRedeem" @submit="redeemSubmit"></registerMeiTuanRedeem>
  </div>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import CustomSelect from '@/components/CustomSelect'
import registerMeiTuanRedeem from '@/components/channelRedeem/registerMeiTuanRedeem'

import { registerStatusList, doctorVisitList } from '@/utils/const'
import { dictText, debounce, isNull } from '@/utils/validateBase'
import { Utils } from '@/utils/utils'
import { CommonDTO } from '@/DTO/index'
import { getShareCoupon } from '@/api/coupon';
import { getTeamReferralDoctorList, setOrderReferral } from '@/api/studio'
import { getChangeRecord, relationSave } from '@/api/register'
import { userList } from "@/api/user"; // 医生列表请求
import { doctorList } from "@/api/doctor"; // 医生列表请求

export default {
  // 定义引入的组件
  components: { CustomDialog, CustomSelect, registerMeiTuanRedeem },
  props: {
    visibleObj: {
      type: Object,
      default: {}
    },
    dialogObj: {
      type: Object,
      default: {}
    }
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      let expPhone = new RegExp(/^1[3456789]\d{9}$/); // 验证手机号码
      if (value != null && value != "") {
        if (expPhone.test(value) == false) {
            return callback(new Error("请输入正确的手机号！"));
        }
        return callback();
      }
      return callback();
    }
    return {
      registerStatusList: registerStatusList,//状态列表
      statusObj: {},//当前状态对象
      show: false,
      PAY_WAY: [],
      sourceConfigList: [],
      couponList: [],
      referralMap: {
        show: false,
        form: {
          doctorId: ''
        },
        rules: {
          doctorId: [{ required: true, message: '请选择转诊医生', trigger: 'change' }]
        }
      },
      changeRecordList: [],
      doctorReferrerOptions: [],
      userOptions: [],
      sourceListConfig: {
        value: 'id',
        label: 'sourceName',
      },//推荐下拉配置
      doctorReferrerOptionsConfig: {
        value: 'doctorId',
        label: 'doctorName',
      },//医生下拉配置
      userOptionsConfig: {
        value: 'userId',
        label: 'nickName',
      },//员工下拉配置
      referrerTypeMap: {
        show: false,
        form: {
          referrer: '',
          referrerDoctorId: '',
          referrerUserId: '',
          referrerPhone: '',
          sourceId: '',
        },
        rules: {
          sourceId: [{ required: true, message: '请选择来源', trigger: 'change' }],
          referrer: [{ required: true, message: '请选择推荐人', trigger: 'change' }],
          referrerPhone: [
            { required: true, message: '请输入推荐人号码', trigger: 'blur' },
            {validator: validatePhone, trigger: 'blur'}
          ],
        },
      }
    }
  },
  // 页面初始化
  async created() {
    this.PAY_WAY = await CommonDTO.getPayWay()
    this.sourceConfigList = await CommonDTO.getSourceConfig()
    if (this.dialogObj.status == '-5') {
      // 取已取消的样式
      this.statusObj = this.registerStatusList.find(item => { return item.value == '-1' })
    } else {
      this.statusObj = this.registerStatusList.find(item => { return item.value == this.dialogObj.status })

      if (['1', '2'].includes(this.dialogObj.status)) {
        let referralRes = await getTeamReferralDoctorList({ doctorId: this.dialogObj.doctorId })
        if (referralRes.code == 200) {
          this.dialogObj.referralDoctorList = referralRes.data.filter(v => { return v.doctorId && v.doctorId != this.dialogObj.doctorId }) || []
        }
      }
    }
    if (this.dialogObj.status > 0) {
      this.getShareCoupon()
    }
    // 改签记录
    this.getChangeRecord()
  },
  filters: {
    filterWay(val, PAY_WAY) {
      return dictText(val, PAY_WAY)
    },
    filterReferrerType(val, list) {
      return list.find(item => { return item.id == val }) && list.find(item => { return item.id == val }).sourceName || ''
    }
  },
  computed: {
    //是否显示签到并打印
    isShowSignPrint() {
      let arr = ['1'];
      // 状态为待签到并且就诊时间不等于今天
      return arr.includes(this.dialogObj.status) && Utils.eq(this.$moment(this.dialogObj.schedulingTime).valueOf(), this.$moment().startOf('day').valueOf())
    },
    //是否显示收费
    isShowCharge() {
      let arr = ['0']; // 
      return arr.includes(this.dialogObj.status);
    },
    // 是否显示签到
    isShowSign() {
      let arr = ['1']; // 
      return arr.includes(this.dialogObj.status) && Utils.eq(this.$moment().startOf('day').valueOf(), this.$moment(this.dialogObj.schedulingTime).startOf('day').valueOf());
    },
    // 是否显示打印
    isShowPrint() {
      let arr = ['1', '2', '3']; // 
      return arr.includes(this.dialogObj.status);
    },
    // 是否显示退号
    isShowReturn() {
      let arr = ['1', '2', '3', '0', '-2']; // 
      return arr.includes(this.dialogObj.status);
    },
    // 超级管理员不限制退号时间
    isSuperAdmin() {
      const roles = this.$session.get('roles') || []
      return Array.isArray(roles) && (roles.includes('admin') || roles.includes('Admin'))
    },
    // 退号禁用：号源日（schedulingTime）当天 08:00 之后不可退，08:00 及之前可退
    // 超级管理员不受此限制，随时可退
    // schedulingTime：就诊日期；timeQuantumName：号源时段
    isRefundDisabled() {
      if(['0','-2'].includes(this.dialogObj.status)) return false
      if (this.isSuperAdmin) return false
      const schedulingTime = this.dialogObj && this.dialogObj.schedulingTime
      if (!schedulingTime) return true
      const visitDate = this.$moment(schedulingTime)
      if (!visitDate.isValid()) return true
      // 号源 = schedulingTime（日期）+ timeQuantumName（时段）
      // 退号截止：该号源日 08:00:00（含），超过则禁用
      const deadline = visitDate.clone().startOf('day').hour(8).minute(0).second(0).millisecond(0)
      return this.$moment().isAfter(deadline)
    },
    // 是否显示转诊
    isShowReferral() {
      let arr = ['1', '2'];
      return arr.includes(this.dialogObj.status) && (this.dialogObj.referralDoctorList && this.dialogObj.referralDoctorList.length > 0);
    },
    // 是否显示改签
    isShowChange() {
      //待签到 已停诊
      let arr = ['1', '-2'];
      return arr.includes(this.dialogObj.status);
    },
    //处理状态
    computedStatus() {
      return this.dialogObj.status == '-5' ? '支付超时' : dictText(this.dialogObj.status, this.registerStatusList)
    },
    //处理患者类型
    computedDoctorVisit() {
      return dictText(this.dialogObj.doctorVisit, doctorVisitList)
    },
    computedReferrerTypeShow() {
      let isBeforeSchedulingTime = this.$moment(this.dialogObj.schedulingTime).add(1, 'days').endOf('day').valueOf() >= this.$moment().endOf('day').valueOf()
      return isBeforeSchedulingTime
    },
    computedDiscountAmount () {
      const price = [null, undefined, ''].includes(this.dialogObj.registerFee) ? this.dialogObj.price : this.dialogObj.registerFee
      const finalPrice = this.dialogObj.finalPrice

      const discountAmount = Math.round((finalPrice - price) * 100) / 100
      return discountAmount > 0 ? `+${discountAmount}` : discountAmount
    }
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    /**
   * 关闭
   */
    dialogVisible(name) {
      this.$emit("close", name);
    },
    /**
     * 签到并打印
     */
    handleRegister: debounce(function () {
      this.$emit('signAndCall')
    }, 1000, true),
    /**
     * 收费
     */
    charge: debounce(function () {
      if (this.dialogObj.couponPrice && this.dialogObj.couponPrice > 0) {
        this.$message.warning('该订单存在优惠券，请在小程序上支付')
      } else {
        this.$emit('updateData', { payWay: this.activeType, userAuthCode: '' })
      }
    }, 1000, true),
    /**
     * 签到
     */
    sign: debounce(async function () {
      this.$emit('sign')
    }, 1000, true),
    /**
     * 打印
     */
    print: debounce(async function () {
      this.$emit('print')
    }, 1000, true),
    /**
     * 退号（超级管理员不限制时间；其他角色超过号源日 08:00 不可退）
     */
    refundRegister: debounce(async function () {
      if (this.isRefundDisabled) {
        this.$message.warning('仅号源日当天8点及8点前可退号')
        return
      }
      this.$emit('refundRegister')
    }, 1000, true),
    async getShareCoupon() {
      let { code, data } = await getShareCoupon({ orderId: this.dialogObj.registeredId, type: 1 })
      if (code == 200) {
        this.couponList = data || []
      }
    },
    onMoreCommand(command) {
      switch (command) {
        case 'refund':
          this.refundRegister()
          break
        case 'referral':
          this.referralOpen()
          break
        case 'change':
          this.changeOpen()
          break
      }
    },
    referralOpen() {
      this.referralMap.show = true
    },
    referralClose() {
      this.referralMap.form.doctorId = ''
      this.$nextTick(() => {
        this.$refs.referralForm.clearValidate()
        this.referralMap.show = false
      })
    },
    referralConfirm: debounce(async function () {
      this.$refs.referralForm.validate(async (valid) => {
        if (valid) {
          const res = await setOrderReferral({
            orderId: this.dialogObj.registeredId,
            doctorId: this.referralMap.form.doctorId
          })
          if (res.code == 200) {
            this.$message.success('转诊成功')
            this.$emit('refresh')
            this.visibleObj.registerDetailDialog = false
          }
        }
      })
    }, 1000, true),
    // 改签
    changeOpen() {
      this.$emit('changeRegister', this.dialogObj)
    },
    // 改签记录
    async getChangeRecord() {
      let { code, data } = await getChangeRecord({ registeredId: this.dialogObj.registeredId })
      if (code == 200) {
        this.changeRecordList = data || []
      }
    },
    editReferrerType() {
      this.referrerTypeMap.show = true
    },
    referrerTypeClose() {
      this.$nextTick(() => {
        this.$refs.referrerTypeForm.clearValidate()
        this.referrerTypeMap.show = false
      })
    },
    async getSourceDoctorList(value) {
      let params = {
        pageNum: 1,
        pageSize: 100,
        status: 0,
        deptId: 0,
        doctorName: value
      }
      let { code, rows } = await doctorList(params)
      if (code == 200) {
        this.doctorReferrerOptions = rows
      }
    },
    async getSourceUserList(value) {
      let params = {
        pageNum: 1,
        pageSize: 100,
        nickName: value,
        deptId: '0'
      }
      let { code, rows } = await userList(params)
      if (code == 200) {
        this.userOptions = rows
      }
    },
    sourceChange() {
      this.doctorReferrerOptions = []
      this.referrerTypeMap.form.referrer = ''
      this.referrerTypeMap.form.referrerDoctorId = ''
      this.referrerTypeMap.form.referrerUserId = ''
      this.referrerTypeMap.form.referrerPhone = ''
    },
    referrerTypeConfirm:debounce(function() {
      this.$refs.referrerTypeForm.validate(async (valid) => {
        if (valid) {
          let form = this.referrerTypeMap.form
          let params = {
            patientId: this.dialogObj.patientId,
            doctorId: this.dialogObj.doctorId,
            orderId: this.dialogObj.registeredId,
            sourceId: form.sourceId,
          }
          if (form.sourceId == 9) {
            params.referrer = form.referrerPhone
          } else if (form.sourceId == 10) {
            params.referrer = form.referrerDoctorId
          } else if (form.sourceId == 11) {
            params.referrer = form.referrerUserId
          }
          let { code, data } = await relationSave(params)
          if (code == 200) {
            this.$message.success('补充患者来源成功')
            this.$emit('refresh')
            this.visibleObj.registerDetailDialog = false
          }
        }
      })
    }, 1000, true),
    /**
     * 核销
     */
    redeem: debounce(async function () {
      this.$refs['registerMeiTuanRedeem'].open(this.dialogObj.registeredId)
    }, 1000, true),
    redeemSubmit () {
      this.$emit('refresh')
      this.visibleObj.registerDetailDialog = false
    }
  }
}
</script>
<style lang="less">
.price-popover {
  background: #FFFDE9;
  padding: 10px;
  box-sizing: border-box;
  font-size: 13px;
  padding-bottom: 0;

  .price-top {
    padding-bottom: 8px;
    color: #000;
  }

  .price-bottom {
    border-top: 1px dashed #E0E0E0;
    padding-top: 8px;
    color: #667182;
    padding-bottom: 8px;
  }
}

.popover-record {
  width: 380px;
  background: #FFFDE9;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;

  .timeline {
    position: relative;

    .timeline-item {
      display: flex;
      position: relative;
      padding-bottom: 16px;

      &:last-child {
        padding-bottom: 0;
      }

      .timeline-dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #EBEAEE;
        border: 2px solid #FFF;
        margin-right: 12px;
        margin-top: 4px;
        flex-shrink: 0;

        &.active {
          background: #409EFF;
        }
      }

      .timeline-line {
        position: absolute;
        left: 5px;
        top: 20px;
        bottom: 0;
        border: 1px dashed #EBEAEE;
      }

      .timeline-content {
        flex: 1;

        .timeline-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 6px;

          .timeline-title {
            font-weight: 500;
            font-size: 13px;
            color: #000000;
          }

          .timeline-time {
            font-weight: 400;
            font-size: 12px;
            color: #667182;
          }
        }

        .timeline-detail {
          font-weight: 400;
          font-size: 13px;
          color: #000000;
          line-height: 20px;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.lockset-tips {
  height: 32px;
  background: #FFFDE9;
  line-height: 32px;
  text-align: center;
  font-weight: 400;
  color: #FE8F1F;
}

/deep/.el-dialog__body {
  padding-top: 0 !important;
}

.header {
  height: 56px;
  padding: 12px 16px;
  box-sizing: border-box;
  position: relative;

  .bg-img {
    position: absolute;
    top: 0;
    left: 0;
    height: 56px;
    width: 100%;
  }

  .header-patient {
    position: relative;
    z-index: 2;
    padding: 6px 12px;
    box-sizing: border-box;
    color: #1F2329;
    font-size: 14px;
    border-radius: 2px;
  }
}

.content {
  color: #000;

  .rigth-line {
    padding-right: 6px;
    padding-left: 3px;
    border-right: 1px solid #EBEAEE;
    flex-grow: 0;
    flex-shrink: 0;

    &:last-child {
      border-right: none
    }

    &:first-child {
      padding-left: 0;
    }
  }

  .change-record {
    margin-left: 16px;
    font-weight: 400;
    font-size: 14px;
    color: #667182;
  }
}

.footer {
  margin-top: 18px;
  padding-bottom: 16px;
  text-align: right;
  padding-right: 24px;

}

.footer-tips {
  color: #667182;
  margin-top: 18px;
  padding: 0 24px;
  padding-bottom: 16px;
}

.referral-status {
  margin: 0 0 0 10px;
  font-size: 14px;
  color: #1890FF;
}

.referral_dialog /deep/ .el-dialog__header {
  display: block;
  padding: 12px 24px;
}

.referral_dialog /deep/ .el-dialog__header .el-dialog__title {
  line-height: 24px;
  font-weight: 600;
  font-size: 16px;
  color: #000000;
}

.referral_dialog /deep/ .el-dialog__header .el-dialog__headerbtn {
  top: 16px
}

.referral_dialog /deep/ .el-dialog__body {
  padding: 0;
}

.referral_dialog /deep/ .el-dialog__footer {
  padding: 12px 24px;
  border-top: 1px solid #E0E0E0;
}

.referral_content {
  box-sizing: border-box;
  padding: 32px 24px;
  width: 100%;
}

.editReferrerType {
  color: crimson;
  cursor: pointer;
}
.referrer-button{
  padding: 0;
}
</style>